<template>
    <div id="toggles">
      <toggle v-for="item in list" :key="item.id" @update='onUpdate' :value='item.value' :disabled='item.disabled' :initial='item.initial'>
        {{ item.name }}
      </toggle>
    </div>
</template>

<script>
import { Mutex } from 'async-mutex'

export default {
  props: {
    list: Array,
    value: Array
  },
  data () {
    return {
      m: new Mutex(),
      v: null
    }
  },
  methods: {
    async onUpdate (payload) {
      const release = await this.m.acquire()
      try {
        if (!this.v) this.v = []
        else this.v = this.v.filter(item => item !== payload.value)
        if (payload.on) this.v.push(payload.value)
        this.$emit('input', this.v)
      } finally {
        release()
      }
    }
  }
}
</script>

<style scoped>

#toggles {
  border: solid 1px transparent;
  border-radius: 0.3em;
  color: #000000;
  margin: 0 0 0.5em 0;
  padding: 0.3em;
}

#toggles.error {
  border-color: #da3832;
}

#toggles .toggle {
  height: 1.4em;
  margin-bottom: 0.2em;
}

#toggles .toggle:last-child {
  margin: 0;
}

</style>
